import { Action } from 'redux'
import { IRoom } from '../../../models/Room'
import { RoomModalActions } from '../../../reducers/bookingCalendar/actionNames'

const requestUpdateRoomModal = (
  roomId: IRoom[keyof Pick<IRoom, 'id'>],
): IUpdateRoomModal => ({
  roomId,
  type: RoomModalActions.RequestUpdateRoomModal,
})

export default requestUpdateRoomModal

export interface IUpdateRoomModal
  extends Action<RoomModalActions.RequestUpdateRoomModal> {
  roomId: IRoom[keyof Pick<IRoom, 'id'>]
}
